import { request, history } from 'ice';
import { Message } from '@b-design/fusion';
import $i18n from '../i18n';
import { queryPathName } from '@/utils/url-parse';

// todo 这块不能添加，会影响安全参数携带
// const BASE_URL = 'https://pre-industrysolutions.alibabacloud.com';

const getCommonHeaders = () => {
  const { userId, userNick, accountId, account, role, spaceId } = window.loggerConfig || {};
  return {
    // rest/intercnn/user/info接口返回的userId
    'logger-user-id': userId || '',
    // rest/intercnn/user/info接口返回的userNick
    'logger-user-nick': encodeURIComponent(userNick || ''),
    // rest/intercnn/user/info接口返回的accountId
    'logger-account-id': accountId || '',
    // rest/intercnn/user/info接口返回的account
    'logger-account': account || '',
    // 当前空间id
    'logger-space': spaceId || '',
    // 当前空间role
    'logger-role': role || '',
    // 当前语言
    'x-locale': $i18n.language || 'en-US',
  };
};

/**
 * GET请求
 * @param url 请求url
 * @param params 请求参数
 * @param options 请求配置项
 * @param hideErrorMessage 是否隐藏默认错误提示
 * @returns res 请求结果
 */
async function RequestGet(url: string, params?: any, options: any = {}, hideErrorMessage = false) {
  const locale = $i18n.language || 'en-US';
  // const locale = 'en-US';

  try {
    const { headers = {}, toRegisterIfNotLogin, ...others} = options || {};
    const getRequestConfig = {
      headers: { 'Content-Type': 'application/json', 'x-locale': locale, ...getCommonHeaders(), ...headers },
      params,
      ...others,
    };
    const res = (await request.get(url, getRequestConfig)) || {};
    if (
      res.errorCode ||
      (!res?.data?.isDuibaUser && (res?.data?.isAliyunPaymentUser === false && res?.data?.accountSrc === 'aliyun'))
    ) {
      // isAliyunPaymentUser === false 未付费用户跳转登陆页
      errorHandler(res, { toRegisterIfNotLogin, hideErrorMessage});
    }
    return res.data;
  } catch (error) {
    errorHandler(error?.response?.data || error, { hideErrorMessage });
  }
}

/**
 * POST请求
 * @param url 请求url
 * @param params 请求参数
 * @param options 请求配置项
 * @param hideErrorMessage 是否隐藏默认错误提示
 * @returns res 请求结果
 */
async function RequestPost(url: string, data?: any, options: any = {}, hideErrorMessage = false) {
  try {
    const { headers = {}, toRegisterIfNotLogin, ...others} = options || {};
    const postRequestConfig = {
      headers: { 'Content-Type': 'application/json', ...getCommonHeaders(), ...headers },
      ...others,
    };
    const res = (await request.post(url, data, postRequestConfig)) || {};
    if (
      res.errorCode ||
      (!res?.data?.isDuibaUser && (res?.data?.isAliyunPaymentUser === false && res?.data?.accountSrc === 'aliyun'))
    ) {
      // isAliyunPaymentUser === false 未付费用户跳转登陆页
      errorHandler(res, { hideErrorMessage, toRegisterIfNotLogin });
    }
    return res.data;
  } catch (error) {
    errorHandler(error?.response?.data || error, { hideErrorMessage });
  }
}

/**
 * 独立页面，不需要登录态
 */
const independentRoutes = ['/emas/preview', '/login'];

/**
 * 错误处理
 * @param error 报错信息
 * @param hideErrorMessage 是否隐藏默认错误提示
 * @returns
 */
export function errorHandler(error, {hideErrorMessage, toRegisterIfNotLogin}: any) {
  const { data, errorCode } = error;
  if (
    errorCode === '401' ||
    errorCode === 401 ||
    (!data?.isDuibaUser && (data?.isAliyunPaymentUser === false && data?.accountSrc === 'aliyun'))
  ) {
    // 报401错误时 从接口获取url 拼好后重定向到login页
    const { href } = window.location;
    let encodeGotoUrl = '';

    if (href.indexOf('redirect') > -1) {
      const str = href.slice(href.indexOf('redirect'));
      encodeGotoUrl = str.slice(str.indexOf('http'));
    } else {
      encodeGotoUrl = encodeURIComponent(href);
    }

    if (!independentRoutes?.includes(queryPathName())) {
     // const href = location.href.split('#/')[0];
     const href = window.location.origin + window.location.pathname
      window.location.replace(`${href}#/login?redirect=${encodeGotoUrl}&type=${toRegisterIfNotLogin ?'signUp' : 'login'}`);
      // history?.push(`/login?redirect=${encodeGotoUrl}`);
    }
  } else {
    const message = $i18n.get({
      id: 'aopf.src.services.request.InterfaceRequestError',
      dm: '接口请求错误',
    });
    if (!hideErrorMessage) {
      Message.error(error?.errorMsg || error?.Detail || message);
    }
    throw error;
  }
}

const Requests = {
  get: RequestGet,
  post: RequestPost,
};

export default Requests;
